<template>
    <modal class="abnormalPayModel" :isShow="isShow"  @keyup.esc="hide">
        <div class="header">押金支付异常订单处理</div>
        <div class="modal-body">
            <div class="filter-box">
                <div class="date-box">
                    <span>交易日期：</span>
                    <el-date-picker class="from-date"
                        :clearable="false"
                        :editable="false"
                        v-model="beginDate"
                        type="date"
                        placeholder=""
                    > </el-date-picker>
                </div>
                <key-board-input class="search" placeholder="客户姓名、手机号检索"
                    v-model="varietySelect"
                    :isBlurClose="true" :isKeyEnterClose="true"
                    :keyOptions="{isKeyDownEnter:true}"
                /> 
                <div class="query-bnt" @click="loadData()">查询</div>
            </div>
            <div class="content-box">
                <div class="data-box">
                    <div class="panel-heading">
                        <div class="td order">序号</div>
                        <div class="td name">客户姓名/手机号</div>
                        <div class="td money">支付金额</div>
                        <div class="td status">支付状态</div>
                        <div class="td edit">操作</div>
                    </div>
                    <div class="scroll-box">
                        <div class="item-box" v-for="(item,index) in pageList" :key="index" >
                            <div class="tr">
                                <div class="td order">{{(pageIndex-1)*pageSize+index+1}}</div>
                                <div class="td name">{{item.Order_ID}}/{{item.Eat_CheckIndex}}</div>
                                <div class="td money red">¥{{item.Balance_FactPay}}</div>
                                <div class="td status">
                                    <template v-if="item.Is_Refund">
                                        <span class="tag">已退款</span>
                                    </template>
                                    <template v-else>
                                        <span class="tag" v-if="item.Biz_Status==0 || item.Biz_Status==1">支付处理中</span>
                                        <span class="tag red" v-else-if="item.Biz_Status==2 && item.CheckOut_Status==0">支付成功，押金保存失败</span>
                                    </template>
                                </div>    
                                <div class="td edit">
                                    <div class="bnt" @click="paySelect(item)" v-if="item.Biz_Status==0 || item.Biz_Status==1">查询支付结果</div>
                                    <div class="bnt" @click="paymentRefund(item)" v-else-if="item.Biz_Status==2 && !item.Is_Refund">撤销支付</div>
                                </div>
                            </div>
                            <div class="more-box">
                                <p>交易时间：{{(new Date(item.Request_Time)).Format("yyyy/MM/dd hh:mm:ss")}}</p>
                                <p class="pay" v-show="item.ChannelTxnNo">交易流水号：{{ item.ChannelTxnNo }}</p>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom-search-box">
                    <div class="page-box-bottom">
                        <page-turning class="last-page" :pageCount="pageCount" v-model="pageIndex" type="up"><i class=" iconfont icon-fangxiangquan-left"></i></page-turning>
                        <span class="page-number">{{pageIndex}}/{{pageCount}}页</span>
                        <page-turning class="next-page" :pageCount="pageCount" v-model="pageIndex"><i class=" iconfont icon-fangxiangquan-right"></i></page-turning>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
        </div>
    </modal>
</template>

<script>
export default {
    emits:["close"],
    props:{
        isShow:Boolean,
    },
    data(){
        return {
            beginDate:new Date(),
            varietySelect:"",
            pageIndex:1,
            pageSize:5,
            listData:[],
        }
    },
    computed:{
        pageFilter(){
            let text=this.varietySelect.trim().toUpperCase();
            if(text){
                return this.listData?.filter(it=>(it.Order_ID||'').toUpperCase().indexOf(text)>=0 || (it.Eat_CheckIndex||'').toUpperCase().indexOf(text)>=0)
            }
            return this.listData;
        },
        pageList(){
            return this.pageFilter?.slice((this.pageIndex-1)*this.pageSize,this.pageIndex*this.pageSize);
        },
        pageCount(){
            if(this.pageFilter){
                return Math.ceil(this.pageFilter.length/this.pageSize)||1;
            }
            return 1;
        }
    },
    watch:{
        varietySelect(){
            this.pageIndex=1;
        }
    },
    mounted(){
        this.loadData();
    },
    methods:{
        hide(){
            this.$emit("close");
        },
        //加载数据
        loadData(){
            const loading = this.$loading({
                text: "获取押金数据中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let userInfo=this.$auth.getUserInfo(); //获取用户id
            this.$httpAES.post("Bestech.CloudPos.SpecialBusinesses.GetAggregatedExceptionSerials", {
                User_ID:userInfo.User_ID,
                Begin_Date:(new Date(this.beginDate)).Format('yyyy-MM-dd'),
                End_Date:(new Date(this.beginDate)).Format('yyyy-MM-dd'),
                AggregatedBusinessTypeEnum:1,//押金
                Operator_Name:userInfo?.Login_Name,
            }).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode!=0){
                    this.$message.error(d.ResponseHeader.ResultDesc)
                    return;
                }else{
                    console.log(d)
                    this.listData=d.ResponseBody?.Serials||[];
                    this.pageIndex=1;
                }
            }).catch((e)=>{
                loading.close();
                this.$alert("押金管理数据加载失败"+e.message, "提示", {confirmButtonText: "确定"});
            });
        },
        /**特殊业务聚合支付结果查询接口 */
        paySelect(item){
            const loading = this.$loading({
                text: "查询支付结果中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let userInfo= this.$auth.getUserInfo();
            this.$httpAES.post("Bestech.CloudPos.SpecialBusinesses.GetAggregatedPaymentResult",{
                Biz_ID:item.Biz_ID,
                User_ID:userInfo.User_ID,
                Operator_Name:userInfo?.Login_Name,
            }).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.$message.success("查询完成");
                    item.Biz_Status=2;
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                this.tableData=[];
                loading.close();
                this.$message.error('查询支付结果失败：'+e.message);
                console.log('查询支付结果失败：',e);
            })
        },
        /**特殊业务聚合支付退款接口 */
        paymentRefund(item){
            const loading = this.$loading({
                text: "撤销支付中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let userInfo= this.$auth.getUserInfo();
            this.$httpAES.post("Bestech.CloudPos.SpecialBusinesses.AggregatedPaymentRefund",{
                Biz_ID:item.Biz_ID,
                RefundReason: "用户申请退款",
                User_ID:userInfo.User_ID,
                Operator_Name:userInfo?.Login_Name,
            }).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.$message.success("撤销支付成功");
                    item.Is_Refund=true;
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                this.tableData=[];
                loading.close();
                this.$message.error('撤销支付失败：'+e.message);
                console.log('撤销支付失败：',e);
            })
        },
    },
}
</script>

<style lang="scss">
@import './abnormalPayModel.scss'
</style>